import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/Tabs';
import ClientIDManager from '../../components/crm/ClientIDManager';
import { Database, Users, Settings, Shield } from 'lucide-react';

const CRMSettings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('client-ids');

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">CRM Settings</h1>
        <p className="mt-1 text-gray-600">
          Configure your CRM system settings and manage client data
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="client-ids" className="flex items-center">
            <Database className="h-4 w-4 mr-2" />
            Client IDs
          </TabsTrigger>
          <TabsTrigger value="fields" className="flex items-center">
            <Settings className="h-4 w-4 mr-2" />
            Custom Fields
          </TabsTrigger>
          <TabsTrigger value="permissions" className="flex items-center">
            <Shield className="h-4 w-4 mr-2" />
            Permissions
          </TabsTrigger>
          <TabsTrigger value="integrations" className="flex items-center">
            <Users className="h-4 w-4 mr-2" />
            Integrations
          </TabsTrigger>
        </TabsList>

        <TabsContent value="client-ids">
          <ClientIDManager />
        </TabsContent>
        
        <TabsContent value="fields">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold mb-4">Custom Fields</h2>
            <p className="text-gray-500">
              Custom field management will be available in a future update.
            </p>
          </div>
        </TabsContent>
        
        <TabsContent value="permissions">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold mb-4">CRM Permissions</h2>
            <p className="text-gray-500">
              Permission management will be available in a future update.
            </p>
          </div>
        </TabsContent>
        
        <TabsContent value="integrations">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold mb-4">CRM Integrations</h2>
            <p className="text-gray-500">
              Integration management will be available in a future update.
            </p>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default CRMSettings;